import { useTranslation } from '@thoughtspot/i18n';
import { Pagination } from '@thoughtspot/radiant-react/widgets/pagination';
import React, { useEffect, useMemo, useState } from 'react';
import { Vertical } from "../../../utils/layouts";
import styles from './list.container.module.scss';
export const ListContainer = ({ data, listViewProps, noDataProps, offSet, testId, isLastBatch, children, paginationSize = 20, actionBar = null, onChangeOffset, headerHeight, isLoading = false, onKeyDown, }) => {
    const { t } = useTranslation();
    const [currentOffset, setCurrentOffset] = useState(offSet);
    useEffect(() => {
        if (!isLoading) {
            setCurrentOffset(offSet);
        }
    }, [offSet, isLoading]);
    const onBatchOffsetChange = (item) => {
        onChangeOffset(item);
    };
    const MetaDataList = useMemo(() => {
        return children;
    }, [children]);
    return (React.createElement(Vertical, { className: styles.listContainer, "data-testid": `${testId}-list`, onKeyDown: onKeyDown, role: "list" },
        React.createElement(MetaDataList, { className: styles.innerContainer, listViewProps: listViewProps, renderActionBar: actionBar, noDataProps: noDataProps, gridHeight: "260px", ...(headerHeight && { headerHeight }) }),
        data.length > 0 && (React.createElement("div", { className: styles.paginationWrapper, "data-testid": `${testId}-paginationId` },
            React.createElement(Pagination.Range, { batchOffset: offSet, batchSize: paginationSize, nextText: t('NEXT'), isNextDisabled: isLastBatch, previousText: t('PREVIOUS'), onBatchOffsetChange: onBatchOffsetChange },
                React.createElement("span", { className: styles.paginationTextWrapper },
                    t('orgs.list.SHOWING'),
                    " \u00A0",
                    React.createElement("span", { className: styles.paginationNumber }, `${currentOffset + 1} - ${currentOffset +
                        data.length}`)))))));
};
//# sourceMappingURL=list.container.js.map